import * as React from "react";
import { makeStyles } from "@fluentui/react-components";
import useState from "react-usestateref";
import { useEffect } from "react";
import { errorMessages, ErrorMessageType } from "../utils/error";
import { Button, Popover } from "antd";

const useStyles = makeStyles({
  root: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minHeight: "100vh",
  },
  errorDialog: {
    display: "flex",
    flexDirection: "column",
    padding: "20px",
    gap: "20px",
    width: "min(520px, 92%)",
    backgroundColor: "#fff",
  },
  content: {
    display: "flex",
    gap: "20px",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "left",
  },
  refreshButtonContainer: {
    display: "flex",
    flexDirection: "row",
    gap: "5px",
  },
  messageContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "0px",
  },
  button: {
    display: "flex",
    justifyContent: "center",
  },
  icon: {
    width: "40px",
    height: "40px",
  },
  message: {
    fontSize: "14px",
    whiteSpace: "pre-wrap",
    lineHeight: 1.5,

  },
  title: {
    fontSize: "16px",
    fontWeight: 600,
    margin: 0,
    marginBottom: "6px",
  },
  infoLink: {
    color: "#1677ff",
    textDecoration: "underline",
    cursor: "pointer",
  },
  footer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginTop: "8px",
    gap: "12px",
  },
  // Use inline styles for buttons to avoid style typing issues
});

const App: React.FC = () => {
  const [message, setMessage] = useState("");
  const [errorKey, setErrorKey] = useState("");
  const styles = useStyles();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const error = params.get("error");
    let errorMessage = "An error occurred.";
    if (error && errorMessages[error]) {
      errorMessage = errorMessages[error];
    }
    setMessage(errorMessage);
    setErrorKey(error || "");
  }, []);

  const RefreshInfo: React.FC<{ popover: boolean }> = ({ popover = true }) => (
    <div style={popover? { maxWidth: 320, fontSize: 12, lineHeight: 1.4 } : { maxWidth: "100%", fontSize: 12, lineHeight: 1.4}}>
      <div style={{ marginBottom: 8 }}>
        Any chart or table produced by AlphaScript in your PowerPoint is linked to an underlying Excel that you would have been prompted to save when the content was created. You can make changes directly to the Excel chart or table and hit the refresh button to see those changes reflected in the image on your PowerPoint.
      </div>
      <div><strong>Step 1:</strong> Open Excel of chart or table image in your PowerPoint (‘PPT’) you want to update.</div>
      <div><strong>Step 2:</strong> Make changes to chart or table in Excel.</div>
      <div><strong>Step 3:</strong> Select image of chart/table in PPT.</div>
      <div><strong>Step 4:</strong> Hit Refresh button in PPT.</div>
      <div style={{ marginTop: 6 }}>… Watch chart/table in PPT update.</div>
    </div>
  );

  const handleClose = () => {
    Office.context.ui.messageParent(ErrorMessageType.CLOSE);
  };

  return (
    <div className={styles.root}>
      <div className={styles.errorDialog}>
        <div className={styles.content}>
          <img src="/assets/circle-xmark-solid.svg" alt="Error" className={styles.icon} />
          <div className={styles.messageContainer}>
          {errorKey === "refresh-info" && (
            <>
            <RefreshInfo popover={false} />
            </>
          )}
          {errorKey !== "refresh-info" && (
          <p className={styles.message}>{message}</p>
          )}
          {(errorKey === "chart-not-selected" || errorKey === "workbook-not-open") && (
            <div className={styles.refreshButtonContainer}>
            
            { "Refresh button"}
            <Popover
              placement="top"
              content={<RefreshInfo popover={true} />}
              trigger="click"              
              >
               <a className={styles.infoLink}>
                 information
               </a>
            </Popover>
            </div>
          )}
          </div>
        </div>
        
        <div className={styles.footer}>
          
          <div className={styles.button}>
            <Button type="default" style={{ minWidth: 100 }} onClick={handleClose}>
              OK
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default App;
